/* @flow */
import React from 'react';
import './pending.css';
import pendingImage from './pending/tile-loading.gif';

function Pending(props) {
  return (
    <div className="Stats pending">
      <img src={pendingImage} alt="Loading..."/>
    </div>
  );
}

export default Pending;



// WEBPACK FOOTER //
// ./src/app/stats/pending.js